import requestService from "api/request";
import clsx from "clsx";
import { formatNumber } from "lib/helpers/format";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useAppSelector } from "store";

const Wallet = () => {
  const { user } = useAppSelector((state) => state.app) as any;
  const [tokens, setTokens] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredTokens, setFilteredTokens] = useState([]);
  const [showBalance, setShowBalance] = useState(true);
  const navigate = useNavigate();
  const { t } = useTranslation();

  function calculateTotalUSDT(data: any) {
    let totalUSDT = 0;
    if (data?.length > 0)
      data.forEach((item: any) => {
        if (item?.symbol !== "USDT")
          totalUSDT += item.amount * item.priceRecent;
      });
    return totalUSDT + user?.real_balance || 0;
  }

  const getTokensProfile = async () => {
    try {
      const res = await requestService.get("/profile/getTokensProfile");
      if (res && res.data) {
        setTokens(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (user) getTokensProfile();
  }, [user]);

  useEffect(() => {
    const results = tokens.filter((token: any) =>
      token?.symbol.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredTokens(results);
  }, [searchTerm, tokens]);

  useEffect(() => {
    setShowBalance(!!parseInt(localStorage.getItem("show_balance") || "1"));
  }, []);
  return (
    <div
      data-v-718a5df5=""
      className="personal-main-container clearfix  p-5 max-w-[1360px]  mx-auto"
    >
      <div data-v-718a5df5="" className="personal-main-content ">
        <div data-v-718a5df5="" className="asset-spot">
          <div>
            {" "}
            <div className="flex flex-col">
              <div className="mb-[20px] pad:mb-16px phone:mb-16px">
                <div
                  aria-label="Breadcrumb"
                  role="navigation"
                  className="bit-breadcrumb"
                >
                  <span className="bit-breadcrumb__item">
                    <span role="link" className="bit-breadcrumb__inner is-link">
                      {/**/}
                      Sising
                      {/**/}
                    </span>
                    <span
                      role="presentation"
                      className="bit-breadcrumb__separator"
                    >
                      /
                    </span>
                  </span>{" "}
                  <span className="bit-breadcrumb__item">
                    <span role="link" className="bit-breadcrumb__inner is-link">
                      {/**/}
                      {t("Tài sản")}
                      {/**/}
                    </span>
                  </span>{" "}
                </div>
              </div>{" "}
              <div className="flex justify-between items-center">
                <span className="text-32px pad:text-20px phone:text-20px font-semibold text-primaryText">
                  {t("Tài khoản spot")}
                </span>{" "}
              </div>
            </div>{" "}
            <div>
              <div className="flex mt-28px mb-40px air:mt-40px air:mb-24px pad:my-24px phone:my-24px phone:flex-col">
                <div className="flex flex-col w-full air:w-full air:pr-0 air:float-none pad:w-full pad:pr-0 pad:float-none phone:w-full phone:pr-0 phone:float-none">
                  <p className="flex align-center mb-8px select-none items-center gap-1">
                    <span className="text-v3TertiaryText inline-block text-16px leading-20px align-text-top">
                      {t("Tổng số dư")}
                    </span>{" "}
                    {showBalance ? (
                      <svg
                        onClick={() => {
                          setShowBalance(false);
                          localStorage.setItem("show_balance", "0");
                        }}
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="size-6 cursor-pointer"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                        />
                      </svg>
                    ) : (
                      <svg
                        onClick={() => {
                          setShowBalance(true);
                          localStorage.setItem("show_balance", "1");
                        }}
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        className="size-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
                        />
                      </svg>
                    )}
                  </p>{" "}
                  <div className="flex items-center  text-v3PrimaryText text-40px font-700 pro:leading-52px air:leading-52px pad:leading-52px phone:text-24px phone:leading-34px">
                    <div
                      dir="ltr"
                      className="inline-block pro:h-52px air:h-52px pad:h-52px phone:h-34px overflow-hidden"
                    >
                      {showBalance
                        ? formatNumber(calculateTotalUSDT(tokens)?.toFixed(2))
                        : "*****"}
                    </div>{" "}
                    <div className="ml-6px !text-40px align-bottom !phone:text-24px phone:align-middle bit-dropdown">
                      <span
                        className="flex items-center text-v3PrimaryText text-40px font-700 cursor-pointer phone:text-24px bit-dropdown-selfdefine"
                        aria-controls="dropdown-menu-8358"
                        role="button"
                        tabIndex={0}
                      >
                        USDT
                      </span>{" "}
                    </div>
                  </div>{" "}
                </div>{" "}
              </div>{" "}
              <div className="">
                <div>
                  <div className="flex items-center flex-wrap">
                    <div className="mr-8px mb-12px bit-dropdown">
                      <div className="bit-button-group">
                        <button
                          onClick={() => navigate("/deposit")}
                          type="button"
                          className="bit-button bit-button--main bit-button--medium is-round"
                        >
                          {/**/}
                          {/**/}
                          {/**/}
                          <span>
                            <span>{t("Nạp")}</span>{" "}
                          </span>
                          {/**/}
                        </button>
                        <button
                          type="button"
                          className="bit-button bit-button--main bit-button--medium is-round bit-dropdown__caret-button"
                          aria-controls="dropdown-menu-5564"
                        >
                          {/**/}
                          {/**/}
                          {/**/}
                          <span>
                            <i className="bit-icon" style={{ fontSize: 16 }}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                aria-hidden="true"
                              >
                                <path d="M16.586 8.5c.89 0 1.337 1.077.707 1.707L12 15.5l-5.293-5.293c-.63-.63-.184-1.707.707-1.707h9.172z" />
                              </svg>
                            </i>
                          </span>
                          {/**/}
                        </button>
                      </div>
                    </div>{" "}
                    <div className="!mb-12px !mr-8px !ml-0">
                      <button
                        onClick={() => navigate("/trading")}
                        type="button"
                        className="bit-button bit-button--default bit-button--medium is-round"
                      >
                        {/**/}
                        {/**/}
                        {/**/}
                        <span>{t("Mua Crypto")}</span>
                        {/**/}
                      </button>
                    </div>{" "}
                    <div className="!mb-12px !mr-8px !ml-0">
                      <button
                        type="button"
                        className="bit-button bit-button--default bit-button--medium is-round"
                        onClick={() => navigate("/withdraw")}
                      >
                        {/**/}
                        {/**/}
                        {/**/}
                        <span>{t("Rút")}</span>
                        {/**/}
                      </button>
                    </div>{" "}
                    {/**/}{" "}
                    {/* <div className="!mb-12px !mr-8px !ml-0">
                      <button
                        type="button"
                        className="bit-button bit-button--default bit-button--medium is-round"
                      >
                     
                        <span>Chuyển</span>
               
                      </button>
                    </div>{" "} */}
                  </div>{" "}
                </div>
              </div>
            </div>{" "}
            <div className="mt-40px air:mt-28px pad:mt-28px phone:mt-12px">
              <div className="bit-tabs bit-tabs--line bit-tabs--top bit-tabs--standard">
                <div className="bit-tabs__header is-top">
                  <div className="bit-tabs__nav-wrap is-top"></div>
                </div>
                <div className="bit-tabs__content">
                  <div
                    role="tabpanel"
                    id="pane-crypto"
                    aria-labelledby="tab-crypto"
                    className="bit-tab-pane"
                  />{" "}
                </div>
              </div>{" "}
              <div
                id="asset_spot_account_tab_bar"
                className="flex items-center mt-5px pad:flex-wrap phone:flex-wrap"
              >
                <div className="w-240px mr-16px phone:w-full phone:mr-0 phone:mb-16px">
                  <div className="bit-input bit-input--standard bit-input--round bit-input--prefix bit-input--suffix bit-input--search">
                    {/**/}
                    {/**/}
                    <input
                      type="text"
                      autoComplete="off"
                      placeholder={t("Tìm kiếm tên coin")}
                      className="bit-input__inner"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <span className="bit-input__prefix">
                      <i className="bit-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path d="M21.53 20.47l-4.694-4.694a8.26 8.26 0 10-1.06 1.06l4.693 4.695a.75.75 0 001.062-1.062zM3.75 10.5a6.75 6.75 0 116.75 6.75 6.758 6.758 0 01-6.75-6.75z" />
                        </svg>
                      </i>
                      {/**/}
                    </span>
                    {/**/}
                    {/**/}
                    {/**/}
                    {/**/}
                    {/**/}
                  </div>
                </div>{" "}
              </div>{" "}
              <div>
                <div data-v-313ab55e="" className="mt-20px">
                  {/**/}{" "}
                  <div
                    data-v-313ab55e=""
                    className="asset_spot_account_virtualList"
                    style={{
                      height: "500px",
                      overflowY: "auto",
                    }}
                  >
                    <div role="group" className="">
                      {!tokens?.length && (
                        <div className="text-[18px] text-[#fff] flex items-center gap-2 mt-4">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="size-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H6.911a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661Z"
                            />
                          </svg>
                          {t("Không có dữ liệu giao dịch")}
                        </div>
                      )}
                      {!!filteredTokens?.length &&
                        filteredTokens?.map((i: any, index: number) => (
                          <div role="listitem" className="" key={index}>
                            <div className="px-8px py-16px border-0 border-b-1px border-solid border-b-line cursor-pointer">
                              <div className="flex justify-between items-center">
                                <div
                                  className="flex items-center text-primaryText"
                                  onClick={() =>
                                    navigate(`/trading?spot=${i?.symbol}`)
                                  }
                                >
                                  <img
                                    src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${i?.tokenId}.png`}
                                    alt=""
                                    className="w-32px h-32px rounded-16px"
                                  />{" "}
                                  <span className="ml-8px font-medium">
                                    {i?.symbol}
                                  </span>
                                </div>{" "}
                              </div>{" "}
                              <div className="flex mt-12px text-primaryText ml-40px gap-4 justify-between">
                                <div className=" box-border phone:mb-12px phone:pr-4px">
                                  <p className="text-thirdText text-fs12">
                                    {t("Số lượng")}
                                  </p>{" "}
                                  <p className="font-medium break-words">
                                    {showBalance
                                      ? formatNumber(i?.amount?.toFixed(3))
                                      : "*****"}
                                  </p>
                                  <div className="text-thirdText flex text-fs12 w-full">
                                    ≈&nbsp;
                                    <span>
                                      {showBalance
                                        ? formatNumber(
                                            (
                                              i?.priceRecent * i?.amount
                                            ).toFixed(3)
                                          )
                                        : "*****"}
                                    </span>
                                  </div>
                                  <p />
                                </div>{" "}
                                <div className=" phone:mb-12px phone:text-right mr-2">
                                  <p className="text-thirdText text-fs12">
                                    {t("Khả dụng")}
                                  </p>{" "}
                                  <p className="font-medium break-words text-center">
                                    {showBalance
                                      ? formatNumber(i?.amount?.toFixed(3))
                                      : "*****"}
                                  </p>
                                </div>{" "}
                                <div className="text-right ">
                                  <p className="text-thirdText text-fs12">
                                    <span
                                      className="bit-tooltip inline-block border-0 border-b-1px border-dashed border-b-thirdText"
                                      aria-describedby="bit-tooltip-3025"
                                      tabIndex={0}
                                    >
                                      {t("Lời&amp;Lỗ hôm nay")}
                                    </span>
                                  </p>{" "}
                                  <p className="font-medium break-words flex justify-end">
                                    <span
                                      className={clsx("font-[500]", {
                                        "text-[#4FD7AC]":
                                          i?.percentChange24h > 0,
                                        "text-[#f1493f]":
                                          i?.percentChange24h < 0,
                                      })}
                                    >
                                      {showBalance
                                        ? i?.percentChange24h?.toFixed(2) + "%"
                                        : "***"}
                                    </span>
                                  </p>
                                  <p className="font-medium break-words flex justify-end">
                                    <span
                                      className={clsx("font-[500]", {
                                        "text-[#4FD7AC]": i?.profitLoss > 0,
                                        "text-[#f1493f]": i?.profitLoss < 0,
                                      })}
                                    >
                                      {showBalance
                                        ? formatNumber(
                                            i?.profitLoss?.toFixed(5)
                                          )
                                        : "*****"}
                                    </span>
                                  </p>
                                </div>
                                <div className="text-right hidden sm:block">
                                  <p className="text-thirdText text-fs12">
                                    <span
                                      className="bit-tooltip inline-block border-0 border-b-1px border-dashed border-b-thirdText"
                                      aria-describedby="bit-tooltip-3025"
                                      tabIndex={0}
                                    >
                                      Action
                                    </span>
                                  </p>{" "}
                                  <p className="font-medium break-words flex justify-end">
                                    <div>
                                      <Link
                                        to={`/trading?spot=${i?.symbol}`}
                                        className="text-primaryHoverBg font-[700]"
                                      >
                                        {t("Giao dịch")}
                                      </Link>
                                    </div>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>{" "}
              </div>
            </div>
          </div>{" "}
        </div>
      </div>
    </div>
  );
};

export default Wallet;
